import PropTypes from 'prop-types';
import React from 'react';
import { map, isEmpty } from 'lodash';
import parties from './ConractParties';
import moment from 'moment-business-days';
import { FormGroup, ControlLabel, FormControl, Grid, Row, Col } from 'react-bootstrap';
import CustomerSearch from 'components/site/customer-search';
import CustomersStore from 'stores/CustomerDetailsStore';
import DatePicker from 'components/time/datepicker';

export default class ContractPropsEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchType: this.props.contract ? this.props.contract.parties : 'shipper',
            userName: this.props.contract.user_name ? this.props.contract.user_name : '',
        };
    }

    componentDidMount() {
        CustomersStore.addChangeListener(this.onChange);
        CustomersStore.reset();
        CustomersStore.clearShippers();
    }

    componentWillUnmount() {
        CustomersStore.removeChangeListener(this.onChange);
    }

    onChange() {
        this.props.onChange('user', CustomersStore.getShipper());
    }

    handleNameChange() {
        return (e) => {
            this.props.onChange('contract_name', e.target.value);
        };
    }

    handlePartiesChange() {
        return (e) => {
            const party = e.target.value;
            this.setState({ searchType: party });
            this.props.onChange('parties', party);
        };
    }

    validateName(name) {
        if (isEmpty(name)) {
            return 'error';
        }
        return '';
    }

    handleShipperAndCarrierSelection() {
        return (value, item) => {
            if (item) {
                this.props.onChange('user', item.value);
                this.props.onChange('user_name', value);
                this.setState({ userName: value });
            }
        };
    }

    handleStartDateChanged() {
        return (date) => {
            const dateMoment = moment(date);
            this.props.onChange('start_date', dateMoment.format('L'));
        };
    }

    handleExpirationDateChanged() {
        return (date) => {
            const dateMoment = moment(date);
            this.props.onChange('expiration_date', dateMoment.format('L'));
        };
    }

    handleTermChange() {
        return (e) => {
            this.props.onChange('term', e.target.value);
        };
    }

    renderCustomerSearch(user) {
        const display = this.state.searchType === user ? 'block' : 'none';
        return (
          <FormGroup style={{ display: display }}>
            <ControlLabel>Select a {user}: </ControlLabel>
            <CustomerSearch
              type={`${user}s`}
              className="form-control"
              onSelect={this.handleShipperAndCarrierSelection()}
              defaultValue={this.state.userName}
            />
          </FormGroup>
        );
    }

    render() {
        const contract = this.props.contract || {};
        return (
          <Grid fluid>
            <Row className="show-grid">
              <Col xs={3}>
                <FormGroup>
                  <ControlLabel>Name</ControlLabel>
                  <FormControl
                    type="text"
                    defaultValue={contract.contract_name}
                    onChange={this.handleNameChange()}
                    bsStyle={this.validateName(contract.contract_name)}
                  />
                </FormGroup>
                <DatePicker
                  label="Select start date"
                  initialDate={contract.start_date || new Date()}
                  onChange={this.handleStartDateChanged()}
                />

              </Col>
              <Col xs={3}>
                <FormGroup>
                  <ControlLabel>Parties</ControlLabel>
                  <FormControl
                    componentClass="select"
                    defaultValue={contract.parties}
                    onChange={this.handlePartiesChange()}>
                    {map(parties, (party, index) => (<option
                      value={party.value}
                      key={`party-${index}`}
                    >{party.name}</option>))}
                  </FormControl>
                </FormGroup>
                <DatePicker
                  label="Select expiration date"
                  initialDate={contract.expiration_date || new Date()}
                  onChange={this.handleExpirationDateChanged()}
                />
              </Col>
              <Col xs={3}>
                {this.renderCustomerSearch('shipper')}
                {this.renderCustomerSearch('carrier')}
                <FormGroup>
                  <ControlLabel>Term</ControlLabel>
                  <FormControl
                    type="number"
                    defaultValue={contract.term}
                    onChange={this.handleTermChange()}
                    bsStyle={(contract.term > 0) ? '' : 'error'}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Grid>
        );
    }
}

ContractPropsEditor.propTypes = {
    contract: PropTypes.object,
    onChange: PropTypes.func,
};
